import ToggleState from 'javascripts/modules/toggle-state.js';

class EffectContribute {

  constructor(){
    this.button = document.querySelector('[data-target="effect-contribute"] button[type=submit]');
    this.loader = document.querySelector('[data-target="effect-contribute-loader"]');
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {

      new ToggleState('effect-contribute', 'active', 'inactive', true);

      if(this.button){

        this.button.addEventListener('click', (event)=> {
          this.loader.setAttribute('data-state', 'active');
        });

        this._listenToFormResult();
      }
    });
  }

  _listenToFormResult(){
    jQuery('[data-target="effect-contribute"] .wpcf7')
      .on('wpcf7:invalid wpcf7:spam wpcf7:mailsent wpcf7:mailfailed wpcf7:submit', 
      (event)=>{
      this.loader.setAttribute('data-state', 'inactive');
    });
  }


}

export let effectContribute = new EffectContribute();
